import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Ads } from '@this/ads';
import {
  Columns,
  Padding
} from '@trulia/txl';
import StyledSectionContainer from '../sharedComponents/StyledSectionContainer/StyledSectionContainer';
import HomeDetailsAdsContent from './HomeDetailsAdsContent';

// This ad should be in feature list section.
export const TelcoFlagAds = (props) => {
  if (props.isAdvertisingRestricted || props.disabledAdSlots.includes('telcoflag_1')) {
    return null;
  }

  return (
    <Padding t={props.includePadding ? 'm' : ''}>
      <Ads
        data-testid="propert-ads-telcoflag_1"
        adSlot={'telcoflag_1'}
        slotSize={'fluid'}
        renderWhenViewable={false}
        viewableThreshold={null}
        displayOnAllDevices={true}
        {...props}
      />
    </Padding>
  );
};

TelcoFlagAds.defaultProps = {
  disabledAdSlots: []
};

// This ad should be in the comparables section.
export const Map1Ads = (props) => {
  if (props.isAdvertisingRestricted || props.disabledAdSlots.includes('map_1')) {
    return null;
  }

  return (
    <Ads
      data-testid="propert-ads-map1"
      adSlot={'map_1'}
      slotSize={'fluid'}
      renderWhenViewable={false}
      viewableThreshold={0}
      displayOnAllDevices={true}
    />
  );
};

Map1Ads.defaultProps = {
  disabledAdSlots: []
};

// This ad should be under the legal protection section.
export const Property1Ads = (props) => {
  if (props.disabledAdSlots.includes('property_1')) {
    return null;
  }

  return (
    <Ads
      data-testid="propert-ads-property_1"
      adSlot={`property_1${props.isAdvertisingRestricted ? '_restricted' : ''}`}
      slotSize={'fluid'}
      renderWhenViewable={true}
      viewableThreshold={0.1}
      displayOnAllDevices={true}
    />
  );
};

Property1Ads.defaultProps = {
  disabledAdSlots: []
};

// This ad should be at the bottom of the page.
export const SubContentAds = (props) => {
  if (props.isAdvertisingRestricted) {
    return null;
  }

  const subContents1Disabled = props.disabledAdSlots?.includes('subcontent_1');
  const subContents2Disabled = props.disabledAdSlots?.includes('subcontent_2');

  if (subContents1Disabled && subContents2Disabled) {
    return null;
  }

  return (
    <Columns align='center' justify={'center'}>
      {
        !subContents1Disabled && (
          <Padding t='xxs' r='xl'>
            <Ads
              data-testid='propert-ads-subcontent_1'
              adSlot={'subcontent_1'}
              slotSize={[[ 300, 250 ], 'fluid' ]}
              renderWhenViewable={false}
              viewableThreshold={null}
              displayOnAllDevices={false}
            />
          </Padding>
        )
      }
      {
        !subContents2Disabled && (
          <Padding t='xxs' l='xl'>
            <Ads
              data-testid="propert-ads-subcontent_2"
              adSlot={'subcontent_2'}
              slotSize={[[ 300, 250 ], 'fluid' ]}
              renderWhenViewable={false}
              viewableThreshold={null}
              displayOnAllDevices={false}
            />
          </Padding>
        )
      }
    </Columns>
  );
};

SubContentAds.defaultProps = {
  disabledAdSlots: []
};

// This ad should be in affordability section
export class HomeExpenseAds extends Component {
  static defaultProps = {
    disabledAdSlots: []
  };

  constructor(props) {
    super(props);

    this.totalAds = 0;

    this.handleReceiveAds = this.handleReceiveAds.bind(this);
    this.showHideContainer = this.showHideContainer.bind(this);
  }

  showHideContainer(show) {
    const costHeader = document.querySelector(
      'div[data-role="costHeader"]',
    );

    if (costHeader) {
      costHeader.style.display = (show) ? 'block' : 'none';
    }
  }

  handleReceiveAds() {
    const totalAds = this.totalAds + 1;
    this.showHideContainer(totalAds > 0);
  }

  render() {
    const { isAdvertisingRestricted, disabledAdSlots } = this.props;
    const style = {
      display: 'none'
    };

    if (isAdvertisingRestricted) {
      return null;
    }

    const homeExpenses1Disabled = disabledAdSlots?.includes('homexpenses_1');
    const homeExpenses2Disabled = disabledAdSlots?.includes('homexpenses_2');

    if (homeExpenses1Disabled && homeExpenses2Disabled) {
      return null;
    }

    return (
      <StyledSectionContainer
        heading={'Additional Cost'}
        data-role="costHeader"
        style={style}
      >
        {
          !homeExpenses1Disabled && (
            <Ads
              data-testid="propert-ads-homeExpenses1"
              adSlot={'homexpenses_1'}
              slotSize={'fluid'}
              renderWhenViewable={false}
              viewableThreshold={null}
              displayOnAllDevices={true}
              onReceiveAds={this.handleReceiveAds}
            />
          )
        }
        {
          !homeExpenses2Disabled && (
            <Ads
              data-testid="propert-ads-homeExpenses2"
              adSlot={'homexpenses_2'}
              slotSize={'fluid'}
              renderWhenViewable={false}
              viewableThreshold={null}
              displayOnAllDevices={true}
              onReceiveAds={this.handleReceiveAds}
            />
          )
        }
      </StyledSectionContainer>
    );
  }
}

class HomeDetailsAds extends Component {
  static fragments = {
    ads: gql`
      fragment HomeDetailsAdsFragment on HOME_Details {
        ads {
          targetings {
            key
            value
          }
          disabledAdSlots
        }
      }
    `
  };

  static propTypes = {
    ads: PropTypes.shape({
      targetings: PropTypes.array.isRequired,
      disabledAdSlots: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired
  }

  render() {
    return <HomeDetailsAdsContent {...this.props}/>;
  }
}

export default HomeDetailsAds;
